import React from 'react';
import PropTypes from 'prop-types';

// Icon
const EditIcon = ({ className, width, height, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 240 240"
  >
    <g>
      <path
        className="icon editIcon"
        fill={fill}
        d="M234.996,43.356c0.147,9.717-4.188,19.13-12.997,28.242c-3.585,3.74-23.984,24.013-61.181,60.838	c-37.196,36.825-64.32,63.681-81.346,80.575c-0.454,0.449-0.942,0.819-1.465,1.104c-0.517,0.302-1.079,0.526-1.679,0.674	c-9.707,2.832-30.327,9.403-61.845,19.726c-0.601,0.293-1.353,0.449-2.241,0.449c-0.303,0-0.6-0.039-0.903-0.117	c-0.298-0.078-0.596-0.156-0.889-0.225c-0.298-0.078-0.601-0.186-0.898-0.322c-0.303-0.166-0.562-0.313-0.792-0.449	c-0.219-0.166-0.478-0.313-0.781-0.459c-0.298-0.146-0.527-0.361-0.669-0.674c-2.09-2.09-2.758-4.551-2.021-7.383	c11.953-39.442,18.232-60.429,18.823-62.978c0.449-1.19,1.118-2.235,2.017-3.134C118.021,67.194,165.301,19.91,167.986,17.361	c8.223-8.213,17.48-12.325,27.792-12.325c4.629,0,9.072,0.967,13.329,2.911c4.259,1.943,8.331,4.794,12.218,8.525	C230.279,24.979,234.83,33.933,234.996,43.356z M29.722,193.852c-3.593,11.123-6.049,18.936-7.402,23.417	c4.932-1.641,13.032-4.345,24.321-8.075c11.279-3.741,18.408-6.124,21.401-7.178c-2.09-6.875-5.684-12.842-10.761-17.93	c-6.431-6.426-13.301-10.605-20.62-12.548C35.621,175.277,33.312,182.699,29.722,193.852z M130.008,75.846	c-15.619,15.547-32.128,32.05-49.53,49.531c-17.407,17.479-28.72,28.837-33.949,34.061c7.764,3.125,14.79,7.833,21.059,14.121	c5.234,5.371,9.341,11.494,12.324,18.379c58.857-58.27,98.376-97.41,118.552-117.439c-0.313-1.484-0.723-3.105-1.23-4.805	c-0.537-1.729-1.729-4.297-3.583-7.734c-1.886-3.438-4.151-6.503-6.847-9.179c-6.563-6.582-13.583-10.762-21.054-12.559	C157.527,48.444,145.613,60.319,130.008,75.846z M218.189,52.312c1.476-2.988,2.237-5.82,2.237-8.516	c0-2.686-0.782-5.45-2.354-8.281c-1.562-2.851-3.847-5.683-6.835-8.525c-2.383-2.392-4.883-4.179-7.5-5.38	c-2.617-1.202-5.273-1.797-7.959-1.797c-2.842,0-5.713,0.674-8.633,2.031c-2.909,1.338-4.911,2.461-6.045,3.36	c-1.112,0.898-2.051,1.718-2.792,2.46l-0.449,0.449c-0.303,0.313-0.527,0.528-0.664,0.674c7.313,3.135,13.964,7.706,19.94,13.671	c5.674,5.831,10,12.627,13.007,20.4c0.284-0.302,0.509-0.518,0.654-0.665c0.147-0.155,0.304-0.312,0.449-0.458	c0.147-0.146,0.225-0.302,0.225-0.44C214.439,58.297,216.696,55.309,218.189,52.312z"
      />
    </g>
  </svg>
);

EditIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};

EditIcon.defaultProps = {
  height: '100%',
  fill: 'currentColor',
};

export default EditIcon;
